module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mx-0 pa-0",
    attrs: {
      "id": "dashboard",
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('div', [_c('b', [_c('u', [_vm._v("Statistics")])])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-sm": "",
      "dark": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-0 mb-0 mx-1",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm9": "",
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-2 mb-0 pa-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs15": ""
    }
  }, [_vm._v("\n                  User Balance: " + _vm._s(_vm.credits) + "\n                  ")])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 mb-0 pa-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs15": ""
    }
  }, [_c('div', {
    staticClass: "silver--text"
  }, [_vm._v("New Orders: " + _vm._s(_vm.orders.new))]), _vm._v(" "), _c('div', {
    staticClass: "silver--text"
  }, [_vm._v("Processing Orders: " + _vm._s(_vm.orders.processing))]), _vm._v(" "), _c('div', {
    staticClass: "silver--text"
  }, [_vm._v("Rejected Orders: " + _vm._s(_vm.orders.rejected))]), _vm._v(" "), _c('div', {
    staticClass: "silver--text"
  }, [_vm._v("Success Orders: " + _vm._s(_vm.orders.replied))]), _vm._v(" "), _c('div', {
    staticClass: "silver--text"
  }, [_vm._v("Total Count: " + _vm._s(_vm.orders.total))])])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d07c06fa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard.vue
// module id = 410
// module chunks = 1